import slugify from '@sindresorhus/slugify';

import { Node, TextNode } from '~/types';

export interface HeadingInfo {
  id: string;
  title: string;
}

export const generateHeadingInfo = (node: Node): HeadingInfo | null => {
  if (node.type === 'heading' && node.tag === 'h2') {
    const headingText =
      node.children
        ?.filter(
          (child: Node): child is TextNode =>
            child.type === 'text' && !!child.text,
        )
        .map((child: TextNode) => child.text)
        .join('') || '';

    const id = slugify(headingText);
    return { id, title: headingText };
  }
  return null;
};
